import { SeedDTO, SeedFormulationConrollerClient, SeedInfoDTO } from '../models/Models';
import ModelFactory from '../models/ModelFactory';
import BaseService from './BaseService';

export default class SeedService extends BaseService {
  async getSeedInfo(treeNodeId: number): Promise<SeedDTO> {
    const client: SeedFormulationConrollerClient = ModelFactory(
      SeedFormulationConrollerClient,
    );
    return await client.getSeedInfo(treeNodeId);
  }

  async getSeeds(seedIds: number[]): Promise<SeedInfoDTO[]> {
    const client: SeedFormulationConrollerClient = ModelFactory(
      SeedFormulationConrollerClient,
    );
    return await client.getSeeds(seedIds);
  }
}
